import React from "react";
import { CitationAnchor } from "./citationStyles";
import { isSafeCitationUrl } from "./citationHelpers";

// Collapsed citation display, shared by the create and edit editors: a clickable
// deep-link when the URL is a safe http/https link, otherwise plain text.
const CitationLink = ({ title, url }) => (
  <span>
    {isSafeCitationUrl(url) ? (
      <CitationAnchor href={url} target="_blank" rel="noopener noreferrer">
        {title}
      </CitationAnchor>
    ) : (
      title
    )}
  </span>
);

export default CitationLink;
